import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutHeroHeadingRight = {
  factory: EElement({
    id: '820fdb93-52e2-b6e1-1793-30051bbf9d6f',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('1956197d-5651-6c6b-db12-2145c8c3541d')]),
      children: EList([
        EElement({
          id: '820fdb93-52e2-b6e1-1793-30051bbf9d70',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '820fdb93-52e2-b6e1-1793-30051bbf9d71',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('37a0db36-0c36-057c-7224-b52f6d799831'),
                  ]),
                  children: EList([
                    EElement({
                      id: '820fdb93-52e2-b6e1-1793-30051bbf9d7b',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('199eff86-56aa-771a-7b1b-0b18fb1f60fa'),
                        ]),
                        children: EList([
                          EElement({
                            id: '820fdb93-52e2-b6e1-1793-30051bbf9d7c',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageHills),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272ff2f2043ec899f7e6449"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('ef341d27-cbbe-501e-0430-474259d4edc3'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '820fdb93-52e2-b6e1-1793-30051bbf9d72',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('199eff86-56aa-771a-7b1b-0b18fb1f60fa'),
                        ]),
                        children: EList([
                          EElement({
                            id: '820fdb93-52e2-b6e1-1793-30051bbf9d75',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h1'),
                              children: EList([
                                EElement({
                                  id: '820fdb93-52e2-b6e1-1793-30051bbf9d76',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Title copy goes here'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '820fdb93-52e2-b6e1-1793-30051bbf9d77',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('1b2031fc-27bc-6bb0-9580-913bd9335308'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '820fdb93-52e2-b6e1-1793-30051bbf9d78',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem. Etiam sodales ac felis id interdum.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '820fdb93-52e2-b6e1-1793-30051bbf9d79',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(true),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('5811e2db-f107-fb36-bedc-ae019c696e30'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '820fdb93-52e2-b6e1-1793-30051bbf9d7a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Get Started'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '1956197d-5651-6c6b-db12-2145c8c3541d',
      type: 'class',
      name: 'Hero Heading Right',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '37a0db36-0c36-057c-7224-b52f6d799831',
      type: 'class',
      name: 'Hero Wrapper',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        medium: {
          styleLess:
            'margin-bottom: -40px; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '199eff86-56aa-771a-7b1b-0b18fb1f60fa',
      type: 'class',
      name: 'Hero Split',
      comb: '',
      styleLess:
        'display: flex; max-width: 46%; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
      children: [],
      variants: {medium: {styleLess: 'max-width: 100%; margin-bottom: 40px;'}},
    },
    {
      _id: 'ef341d27-cbbe-501e-0430-474259d4edc3',
      type: 'class',
      name: 'Shadow Two',
      comb: '',
      styleLess:
        'box-shadow: 0 4px 24px 0 hsla(214.83870967741936, 17.32%, 64.90%, 0.08);',
      children: [],
      variants: {},
    },
    {
      _id: '1b2031fc-27bc-6bb0-9580-913bd9335308',
      type: 'class',
      name: 'Margin bottom 24px',
      comb: '',
      styleLess: 'margin-bottom: 24px;',
      children: [],
      variants: {},
    },
    {
      _id: '5811e2db-f107-fb36-bedc-ae019c696e30',
      type: 'class',
      name: 'Button Primary',
      comb: '',
      styleLess:
        'padding-top: 12px; padding-right: 25px; padding-bottom: 12px; padding-left: 25px; background-color: #1a1b1f; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: hsla(0, 0.00%, 100.00%, 1.00); font-size: 12px; line-height: 20px; letter-spacing: 2px; text-transform: uppercase;',
      children: [
        '7a50e611-1678-13fa-5f6c-0c95173beacf',
        '0333fb64-65a4-0eb3-2546-375483e0a446',
      ],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #32343a; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        main_active: {styleLess: 'background-color: #43464d;'},
      },
    },
  ],
} as const;
